import { GraduationCap } from "lucide-react";
import { Card, CardContent, CardTitle } from "../ui/card";

const CategoryCard = ({ title }: { title: string }) => {
  return (
    <Card className="hover:shadow-lg transition-shadow duration-200 cursor-pointer h-full">
      <CardContent className="space-y-4">
        <div
          className={`w-12 h-12 bg-(--primary-color) rounded-lg flex items-center justify-center`}
        >
          <GraduationCap className="w-6 h-6 text-white" />
        </div>
        <CardTitle className="text-xl">
          {title?.split("|")[0] ?? title}
        </CardTitle>
      </CardContent>
    </Card>
  );
};

export default CategoryCard;
